import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./SideNav.css";
import { LanguageContext, roleContext } from "../../../libs/context";
// import './SideNavRtl.css';
class AdminSideNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: localStorage.getItem("role"),
    };
  }
  componentDidMount() {
    console.log("Admin Pro", this.props);
  }

  render() {
    let admin = "";
    return (
      <React.Fragment>
        <roleContext.Consumer>
          {(role) => (
            <ul>
              <li>
                <NavLink to="/dashboard" activeClassName="activeTabNav">
                  <span className="imgLink">
                    <img
                      src="/images/darkblue24icons/db-dashboard-24.png"
                      alt="dashboard"
                    />
                  </span>
                  <span className="txtLink">
                    {this.props.language.instavc_dashboard}
                  </span>
                </NavLink>
              </li>
              {(role === "Admin" || role === "subAdmin") ? (
                <li>
                  <NavLink
                    to="/admin/user-management"
                    activeClassName="activeTabNav"
                  >
                    <span className="imgLink">
                      <img src="/images/users.png" alt="users" />
                    </span>
                    <span className="txtLink">
                      {this.props.language.instavc_admin_users}
                    </span>
                  </NavLink>
                </li>
              ) : (
                ""
              )}

              <li>
                <NavLink
                  to="/admin/class-management"
                  activeClassName="activeTabNav"
                >
                  <span className="imgLink">
                    <img src="/images/classes.png" alt="classes" />
                  </span>
                  <span className="txtLink">{this.props.language.classes}</span>
                </NavLink>
              </li>
              {role === "Admin" || role === "teacher" || role === "subAdmin" ? (
                <>
                  <li>
                    <NavLink
                      to="/admin/classmanagement/quesstionare"
                      activeClassName="activeTabNav"
                    >
                      <span className="imgLink">
                        <img
                          src="/images/blue/questionnaire.png"
                          alt="quesstionare"
                        />
                      </span>
                      <span className="txtLink">
                        {this.props.language.questionnaire}
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/admin/classmanagement/assignment"
                      activeClassName="activeTabNav"
                    >
                      <span className="imgLink">
                        <img
                          src="/images/blue/assignment.png"
                          alt="assignment"
                        />
                      </span>
                      <span className="txtLink">
                        {this.props.language.assignments}
                      </span>
                    </NavLink>
                  </li>
                </>
              ) : (
                ""
              )}
            </ul>
          )}
        </roleContext.Consumer>
      </React.Fragment>
    );
  }
}

export default AdminSideNav;
